import { VerifilinkReport } from 'components/Report';
import { endpoints } from 'api';

function VerifilinkCompletedPage() {
    return (
        <VerifilinkReport APIEndpoint={endpoints.VL_GROUP_BY_COMPLETED} ReportName='Verifilink Completed' />
    );
}
export default VerifilinkCompletedPage;
